import { Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import React, { useEffect } from "react";
import { useAppDispatch } from "../redux/utils/hook";
import { initializeAuth } from "../redux/admin/adminSlice";
import { onAuthStateChanged } from "@firebase/auth";
import { firebaseAuth } from "../config/firebase";
import { UserDetailsType } from "../types/admin/adminTypes";

interface ProtectedRouteProps {
  element: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element }) => {
  const phoneNumber = localStorage.getItem("phoneNumber");
  const navigation = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(firebaseAuth, (user) => {
      if (!user && location.pathname.startsWith("/admin")) {
        navigation("/admin/login", { replace: true });
      }
    });

    return () => unsubscribe();
  }, [location.pathname]);

  useEffect(() => {
    const handleInitializeAdmin = async () => {
      const data = (await dispatch(initializeAuth()))
        ?.payload as UserDetailsType;

      return data?.uid
        ? navigation("/admin", { replace: true })
        : navigation("/admin/login", { replace: true });
    };

    if (location.pathname === "/admin") {
      handleInitializeAdmin();
    }
  }, [location.pathname]);

  if (!phoneNumber && location.pathname !== "/admin") {
    return <Navigate to="/login" replace />;
  }

  return <>{element}</>;
};

export default ProtectedRoute;
